import React from 'react';
import Typography from '@mui/material/Typography';
import { TableData } from '../types';
import { getTableStats, getInitials } from '../utils/helpers';

interface TableDetailsProps {
  selectedTable: TableData;
}

export const TableDetails: React.FC<TableDetailsProps> = ({ selectedTable }) => {
  return (
    <div>
      <div style={{ marginBottom: '16px' }}>
        <Typography variant="h6" sx={{ fontWeight: 600, marginBottom: '8px' }}>
          Table Details
        </Typography>
        <div style={{ display: 'flex', gap: '12px', fontSize: '0.875rem', color: '#6b7280', marginBottom: '16px' }}>
          <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#22c55e' }}></span>
            {getTableStats(selectedTable).checkedIn} Checked In
          </span>
          <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#ef4444' }}></span>
            {getTableStats(selectedTable).notCheckedIn} Not Checked In
          </span>
          <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#9ca3af' }}></span>
            {getTableStats(selectedTable).emptySeats} Empty
          </span>
        </div>
      </div>

      <Typography variant="h6" sx={{ fontWeight: 600, marginBottom: '12px' }}>
        Attendees
      </Typography>
      
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        {selectedTable.attendees.map(attendee => (
          <div key={attendee.id + attendee.assignedTicket?.name} style={{
            padding: '12px',
            borderRadius: '8px',
            background: '#f9fafb',
            border: '1px solid #e5e7eb',
            borderLeft: `4px solid ${attendee.assignedTicket?.checkedIn ? '#22c55e' : '#ef4444'}`
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <div style={{
                width: '40px',
                height: '40px',
                borderRadius: '50%',
                background: attendee.assignedTicket?.checkedIn ? '#86efac' : '#fca5a5',
                color: attendee.assignedTicket?.checkedIn ? '#064e3b' : '#7f1d1d',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 600,
                fontSize: '14px'
              }}>
                {getInitials(attendee.name)}
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 500, color: '#1f2937', marginBottom: '2px' }}>
                  {attendee.name}
                </div>
                <div style={{ color: '#6b7280', fontSize: '0.875rem' }}>
                  {attendee.company || ''}
                </div>
                {attendee.mealType && (
                  <div style={{ color: '#8b5cf6', fontSize: '0.75rem', fontWeight: 500 }}>
                    {attendee.mealType}
                  </div>
                )}
                {/* Ticket Name Badge */}
                {attendee.assignedTicket?.name && (
                  <div style={{ 
                    display: 'inline-block',
                    padding: '1px 4px',
                    backgroundColor: '#dbeafe',
                    color: '#1e40af',
                    borderRadius: '3px',
                    fontSize: '0.65rem',
                    fontWeight: 500,
                    marginTop: '2px'
                  }}>
                    {attendee.assignedTicket.name}
                  </div>
                )}
              </div>
              <div style={{ 
                fontSize: '0.75rem', 
                color: attendee.assignedTicket?.checkedIn ? '#22c55e' : '#ef4444',
                fontWeight: 500
              }}>
                {attendee.assignedTicket?.checkedIn ? 'Checked In' : 'Not Checked In'}
              </div>
            </div>
          </div>
        ))}
        
        {Array(getTableStats(selectedTable).emptySeats).fill(null).map((_, index) => (
          <div key={`empty-${index}`} style={{
            padding: '12px',
            borderRadius: '8px',
            background: '#f9fafb',
            border: '1px dashed #e5e7eb',
            color: '#9ca3af',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontStyle: 'italic'
          }}>
            Empty Seat
          </div>
        ))}
      </div>
    </div>
  );
}; 